import React from 'react'

import Layout from '../components/layout'
import Profile from '../components/profile'

const IndexPage = () => (
  <Layout>
    <Profile />
  </Layout>
)

export default IndexPage
